import ProgramacaoCopia from './ProgramacaoCopia';

export default ProgramacaoCopia;